export default __webpack_public_path__ + "static/media/black-madam.90ce848a.jpg";